/**
 * Telas do SICOP — todas implementadas: `dashboard`, `reports`, `lines`,
 * `accounts`, `jobs` (Serviços assíncronos), `status`, `audit`, `apis`
 * (Administração), `notifications` e `profile`.
 *
 * O id também é o caminho da tela na URL (ver `lib/routes.ts`), então renomear
 * um deles muda o endereço que as pessoas têm salvo.
 */
export type ScreenId =
  | 'dashboard'
  | 'reports'
  | 'lines'
  | 'accounts'
  | 'masters'
  | 'jobs'
  | 'status'
  | 'apis'
  | 'audit'
  | 'notifications'
  | 'profile';

export interface NavItem {
  id: ScreenId;
  /** Texto do menu. */
  label: string;
  /** Título mostrado no cabeçalho da tela. */
  title: string;
  /** `d` do <path> do ícone (traçado, viewBox 24). */
  icon: string;
}

export const NAV_ITEMS: NavItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    title: 'Dashboard',
    icon: 'M4 4h7v7H4zM13 4h7v4h-7zM13 11h7v9h-7zM4 14h7v6H4z',
  },
  {
    id: 'reports',
    label: 'Relatórios',
    title: 'Relatórios de consumo',
    icon: 'M6 3h9l4 4v14H6zM14 3v5h5M9 12h6M9 16h6',
  },
  { id: 'lines', label: 'Linhas', title: 'Linhas', icon: 'M7 2h10v20H7zM11 18h2' },
  { id: 'accounts', label: 'Contas', title: 'Contas', icon: 'M4 6h16v12H4zM4 10h16' },
  {
    id: 'masters',
    label: 'Masters',
    title: 'Masters e ciclos de faturamento',
    icon: 'M4 21V7l8-4 8 4v14M9 21v-6h6v6M9 10h.01M15 10h.01',
  },
  {
    id: 'jobs',
    label: 'Serviços assíncronos',
    title: 'Serviços assíncronos',
    icon: 'M20 12a8 8 0 1 1-2.3-5.6M20 3v4h-4',
  },
  {
    id: 'status',
    label: 'Status',
    title: 'Status das dependências',
    icon: 'M3 12h4l2-5 4 10 2-5h6',
  },
  {
    id: 'audit',
    label: 'Auditoria',
    title: 'Auditoria',
    icon: 'M12 8v5l3 2M12 3a9 9 0 1 0 9 9',
  },
  {
    id: 'apis',
    label: 'Administração',
    title: 'Administração — URLs dos portais',
    icon: 'M4 7h16M4 12h16M4 17h16M9 5v4M15 10v4M7 15v4',
  },
];

/**
 * Fora do `NAV_ITEMS` de propósito: como no design, a central se abre pelo sino
 * do cabeçalho, e não por um item de menu que competiria com ele.
 */
export const NOTIFICATIONS_ITEM: NavItem = {
  id: 'notifications',
  label: 'Notificações',
  title: 'Notificações',
  icon: 'M6 16v-5a6 6 0 0 1 12 0v5l2 3H4zM10 21h4',
};

export const PROFILE_ITEM: NavItem = {
  id: 'profile',
  label: 'Perfil',
  title: 'Perfil',
  icon: 'M12 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8zM4 21c1.5-4 5-6 8-6s6.5 2 8 6',
};

/** No celular só cabem três atalhos + "Mais"; o resto vai para o bottom sheet. */
export const MOBILE_TAB_IDS: ScreenId[] = ['dashboard', 'lines', 'status'];

export function screenTitle(screen: ScreenId): string {
  return (
    [...NAV_ITEMS, NOTIFICATIONS_ITEM, PROFILE_ITEM].find((item) => item.id === screen)?.title ??
    'SICOP'
  );
}
